/**
 * Majlis Mart - product gallery swipe for phones. Swiping the main image moves to the next or
 * previous picture by using the existing thumbnail buttons, so it needs nothing else to change.
 */
(function () {
  'use strict';
  var doc = document;
  function ready(fn) {
    if (doc.readyState !== 'loading') fn();
    else doc.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var stage = doc.querySelector('.mm-product-media-stage');
    if (!stage) return;
    var x0 = 0, y0 = 0, t0 = 0, tracking = false;

    stage.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) { tracking = false; return; }
      x0 = e.touches[0].clientX;
      y0 = e.touches[0].clientY;
      t0 = Date.now();
      tracking = true;
    }, { passive: true });

    stage.addEventListener('touchend', function (e) {
      if (!tracking) return;
      tracking = false;
      var t = e.changedTouches[0];
      var dx = t.clientX - x0;
      var dy = t.clientY - y0;
      if (Math.abs(dx) < 48 || Math.abs(dx) < Math.abs(dy) * 1.4 || Date.now() - t0 > 600) return;

      var thumbs = Array.prototype.slice.call(doc.querySelectorAll('.mm-product-thumb'));
      if (thumbs.length < 2) return;
      var current = 0;
      thumbs.forEach(function (b, i) { if (b.classList.contains('is-active')) current = i; });
      var rtl = doc.documentElement.dir === 'rtl';
      var forward = rtl ? dx > 0 : dx < 0;
      var next = thumbs[(current + (forward ? 1 : -1) + thumbs.length) % thumbs.length];
      next.click();

      var row = next.parentElement;
      if (row && row.scrollWidth > row.clientWidth) {
        row.scrollTo({ left: next.offsetLeft - (row.clientWidth - next.offsetWidth) / 2, behavior: 'smooth' });
      }
    }, { passive: true });
  });
})();
